// extracted by mini-css-extract-plugin
export default {"header":"AlumnoHeader_header__8moeH","headerIcon":"AlumnoHeader_headerIcon__Wrjcv"};